import { callGet, callPost, callDelete } from "../integrations/calls";

import { REQ } from "../../libs/constants";

export const createAlert = async (data, token) => {
  return await callPost(REQ.ALERT.ADD, data, token);
};

export const getAlert = async (data, token) => {
  return await callPost(`${REQ.ALERT.GET_ALERT}`, data, token);
};

export const getAllAlert = async (token) => {
  return await callGet(`${REQ.ALERT.GET_ALL_ALERT}`, token);
};

export const deleteSale = async (id, token) => {
  return await callDelete(`${REQ.ALERT.DELETE_ALERT}/${id}`, {}, token);
};
